"use client";

import { useEffect } from 'react';
import { initializeMarketingIds } from '@/utils/marketingIds';

export const MarketingIdInitializer = () => {
  useEffect(() => {
    initializeMarketingIds();
  }, []);
  return null;
};
